import { render, staticRenderFns } from "./DeclaredValueDetails.vue?vue&type=template&id=c8221dcc&scoped=true"
import script from "./DeclaredValueDetails.vue?vue&type=script&lang=ts"
export * from "./DeclaredValueDetails.vue?vue&type=script&lang=ts"
import style0 from "./DeclaredValueDetails.vue?vue&type=style&index=0&id=c8221dcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8221dcc",
  null
  
)

export default component.exports